<section class="section about" id='about'>
    <div class="container">
        <div class="section-box">
            <div class="about-title" data-aos="fade-up">
                <h3 class="section-title">
                    <span class='n-section-title'>01.</span> About me
                </h3>
            </div>
            <div class="row">
                <div class="col-12 col-md-6 mb-4 mb-md-0">
                    <div class="about-description">
                        <p   data-aos="fade-up" data-aos-duration="1000">
                            In my  <span class="underline"> 2 years as a developer</span>, I seek to train every day. I am performing <span class="underline">continuous integration </span>, and covering front-end developer roles with
                        </p>

                        <p>
                           <span class="underline"> JavaScript, TypeScript, Angular, ES6</span>. I have led teams having empathy, exercising motivation to partners, and setting plans and goals together.
                        </p>

                        <p>My skills also include implementing system improvements, optimizing sites, standardizing patterns, and suggesting and executing ideas that add value to the project I'm working on.</p>


                        <p>Some of the technologies that I have trained and worked on include (but are not limited to):</p>
                        <ul class="skills-list" data-aos="fade-up">
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">Angular </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">RxJS </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">HTML </span></li>
                        
                
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">(S)CSS </span></li>
                 
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">TypeScript </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">JavaScript </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">JQuery </span></li>
                            <li class="skill-element" data-aos="fade-up" data-aos-duration="1000"><span class="underline">Bootstrap, Material </span></li>
                        </ul>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-4 mt-md-0 text-center" data-aos="fade-up" data-aos-duration="1000">
                    <div class="about-img-container">
                        <img (click)='analyticsService.sendAnalyticEvent("click_image", "about", "image")'  width="300" height="300" src="assets/images/me/loay.jpg" alt="Git User">
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
